import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast"; // ← add this
import { AppProvider } from "./context/AppContext";
import tokenManager from "./utils/tokenManager";

import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import GetStarted from "./components/auth/GetStarted";
import JoinCompany from "./components/auth/JoinCompany";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordResetSuccess from "./components/auth/PasswordResetSuccess";
import NewPassword from "./components/auth/NewPassword";
import EmailVerification from "./components/auth/EmailVerification";
import Layout  from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Requests from './pages/Requests';
import Calendar from './pages/Calendar';
import Team from './pages/Team';
import Policy from './pages/Policy';
import Settings from './pages/Settings';
import Integrations from './pages/Integrations';
import ResetPasswordScreen from './components/auth/ResetPasswordScreen';
import ActivatePage from './pages/ActivatePage';
import NewPasswordScreen from "./components/auth/NewPasswordScreen";

// /billing (used in emails and after Stripe checkout) and /leave-policies
// open the matching Settings section, keeping any ?checkout=… query.
function SettingsSection({ section }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/settings", search, hash: `#${section}` }} replace />;
}

function App() {
  return (
    <AppProvider>
      {/* ── Toast notifications — must be at root level ── */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            fontSize: '13px',
            fontWeight: 500,
            borderRadius: '10px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          },
          success: {
            style: {
              background: '#f0fdf4',
              color: '#15803d',
              border: '1px solid #bbf7d0',
            },
          },
          error: {
            style: {
              background: '#fef2f2',
              color: '#dc2626',
              border: '1px solid #fecaca',
            },
          },
        }}
      />

      <Router>
        <Routes>
          {/* Public routes */}
          <Route
            path="/"
            element={<Navigate to={tokenManager.hasSession() ? "/dashboard" : "/login"} replace />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/join" element={<JoinCompany />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<PasswordResetSuccess />} />
          <Route path="/reset-password/:token" element={<NewPasswordScreen />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/invite/:token" element={<ResetPasswordScreen />} />
          <Route path="/activate" element={<ActivatePage />} />

          {/* Protected routes - with sidebar via Layout */}
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/requests"  element={<Requests />} />
            <Route path="/calendar"  element={<Calendar />} />
            <Route path="/team"      element={<Team />} />
            <Route path="/policy"    element={<Policy />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/settings"  element={<Settings />} />
            <Route path="/billing"   element={<SettingsSection section="billing" />} />
            <Route path="/leave-policies" element={<SettingsSection section="leave-policies" />} />
          </Route>

          {/* Unknown URL → never a blank page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;